// Pages événements et destinations : contenu FR/EN, une entrée par page.
// Les titres et descriptions pour Google sont dans src/seo/pages.json.

const events = [
  {
    slug: 'grand-prix-monaco',
    path: '/evenements/grand-prix-monaco',
    kind: 'event',
    fr: {
      name: 'Grand Prix de Monaco',
      label: 'Événement',
      title: 'Protection rapprochée au Grand Prix de Monaco',
      period: 'Fin mai — Monaco',
      intro: "Pendant le week-end du Grand Prix, la Principauté se transforme : circuit en pleine ville, accès fermés, port saturé de yachts et soirées privées jusqu'au bout de la nuit. Depuis notre bureau de Monaco, nous accompagnons dirigeants, familles et personnalités qui veulent profiter de l'événement sans exposition inutile.",
      challengesTitle: 'Les enjeux du week-end',
      challenges: [
        'Une foule dense et des rues fermées qui rendent chaque déplacement plus long et plus exposé.',
        'Des passages fréquents entre hôtels, terrasses, paddock et yachts du port Hercule.',
        'Une forte présence de photographes et de curieux autour des personnalités.',
        "Des transferts depuis l'aéroport de Nice à anticiper, par la route ou par hélicoptère."
      ],
      approachTitle: 'Notre dispositif',
      approach: [
        "Reconnaissance préalable des accès, des points de sortie et des itinéraires de repli autour du circuit.",
        'Agents de protection rapprochée bilingues, titulaires de la carte professionnelle, présents du premier transfert au dernier départ.',
        'Coordination avec les hôtels, les capitaines de yacht, les organisateurs de réceptions et nos chauffeurs.',
        'Suivi en temps réel par notre centre opérationnel 24/7.'
      ],
      faq: [
        { q: "Combien de temps à l'avance faut-il réserver ?", a: "Idéalement plusieurs semaines avant l'événement : c'est la période la plus demandée de l'année à Monaco. Nous étudions aussi les demandes de dernière minute." },
        { q: 'Pouvez-vous assurer la protection à bord d’un yacht ?', a: "Oui. Le dispositif est préparé avec l'équipage pour couvrir les embarquements, les réceptions à bord et les déplacements à terre." },
        { q: 'Vos agents parlent-ils anglais ?', a: 'Oui, nos agents interviennent en français et en anglais, et nous constituons les équipes selon les langues de nos clients.' }
      ]
    },
    en: {
      name: 'Monaco Grand Prix',
      label: 'Event',
      title: 'Close Protection at the Monaco Grand Prix',
      period: 'Late May — Monaco',
      intro: 'During Grand Prix weekend the Principality changes completely: a street circuit, closed roads, a harbour packed with yachts and private parties late into the night. From our Monaco office, we look after executives, families and public figures who want to enjoy the event without needless exposure.',
      challengesTitle: 'What the weekend involves',
      challenges: [
        'Dense crowds and closed roads that make every movement longer and more exposed.',
        'Constant moves between hotels, terraces, the paddock and yachts in Port Hercule.',
        'Heavy presence of photographers and onlookers around well-known guests.',
        'Transfers from Nice airport to plan ahead, by road or by helicopter.'
      ],
      approachTitle: 'Our approach',
      approach: [
        'Advance reconnaissance of access points, exits and fallback routes around the circuit.',
        'Licensed, bilingual close protection officers from the first transfer to the final departure.',
        'Coordination with hotels, yacht captains, event hosts and our drivers.',
        'Real-time monitoring by our 24/7 operations center.'
      ],
      faq: [
        { q: 'How far in advance should we book?', a: 'Ideally several weeks before the event: it is the busiest period of the year in Monaco. We also consider last-minute requests.' },
        { q: 'Can you provide protection on board a yacht?', a: 'Yes. The detail is planned with the crew to cover boarding, receptions on board and movements ashore.' },
        { q: 'Do your officers speak English?', a: 'Yes, our officers work in French and English, and we build each team around our clients’ languages.' }
      ]
    }
  },
  {
    slug: 'festival-cannes',
    path: '/evenements/festival-cannes',
    kind: 'event',
    fr: {
      name: 'Festival de Cannes',
      label: 'Événement',
      title: 'Protection rapprochée au Festival de Cannes',
      period: 'Mi-mai — Cannes',
      intro: "Montée des marches, rendez-vous sur la Croisette, soirées dans les villas du cap d'Antibes : pendant le Festival, chaque apparition est scrutée. Nous protégeons talents, producteurs, invités et délégations avec la discrétion qu'exige un événement suivi par la presse du monde entier.",
      challengesTitle: 'Les enjeux du Festival',
      challenges: [
        'Une exposition médiatique maximale à chaque arrivée et à chaque sortie.',
        'Des foules de fans et de photographes devant les hôtels de la Croisette.',
        'Un agenda dense, entre projections, interviews, dîners et soirées privées.',
        'Une circulation saturée entre Cannes, Antibes et les villas des hauteurs.'
      ],
      approachTitle: 'Notre dispositif',
      approach: [
        "Préparation de chaque apparition : horaires, accès, entrées et sorties discrètes.",
        'Agents de protection rapprochée en tenue adaptée aux cérémonies et aux soirées.',
        'Chauffeurs spécialisés et itinéraires préparés pour respecter un planning minuté.',
        'Coordination avec les agents, attachés de presse et équipes de production.'
      ],
      faq: [
        { q: 'Protégez-vous aussi les soirées privées ?', a: "Oui. Nous intervenons sur les dîners et soirées organisés en marge du Festival, en lien avec les organisateurs et leurs équipes de sécurité." },
        { q: 'Pouvez-vous intervenir pour une seule journée ?', a: "Oui, de la montée des marches seule à l'ensemble du Festival, le dispositif s'adapte à votre programme." },
        { q: 'Comment préservez-vous la confidentialité ?', a: "Nos agents sont tenus par des accords de confidentialité stricts et nous ne communiquons jamais sur nos clients." }
      ]
    },
    en: {
      name: 'Cannes Film Festival',
      label: 'Event',
      title: 'Close Protection at the Cannes Film Festival',
      period: 'Mid-May — Cannes',
      intro: 'Red carpets, meetings on the Croisette, parties in the villas of Cap d’Antibes: during the Festival every appearance is watched. We protect talent, producers, guests and delegations with the discretion an event followed by the world’s press demands.',
      challengesTitle: 'What the Festival involves',
      challenges: [
        'Maximum media exposure at every arrival and departure.',
        'Crowds of fans and photographers outside the hotels on the Croisette.',
        'A packed schedule of screenings, interviews, dinners and private parties.',
        'Gridlocked traffic between Cannes, Antibes and the hillside villas.'
      ],
      approachTitle: 'Our approach',
      approach: [
        'Planning for every appearance: timings, access, discreet entrances and exits.',
        'Close protection officers dressed for ceremonies and evening events.',
        'Specialist drivers and prepared routes to keep a tight schedule.',
        'Coordination with agents, publicists and production teams.'
      ],
      faq: [
        { q: 'Do you also cover private parties?', a: 'Yes. We work at dinners and parties held around the Festival, alongside the hosts and their security teams.' },
        { q: 'Can you cover a single day?', a: 'Yes, from one red carpet to the whole Festival, the detail fits your schedule.' },
        { q: 'How do you protect confidentiality?', a: 'Our officers are bound by strict non-disclosure agreements and we never talk about our clients.' }
      ]
    }
  },
  {
    slug: 'monaco-yacht-show',
    path: '/evenements/monaco-yacht-show',
    kind: 'event',
    fr: {
      name: 'Monaco Yacht Show',
      label: 'Événement',
      title: 'Protection rapprochée au Monaco Yacht Show',
      period: 'Fin septembre — Monaco',
      intro: "Le Monaco Yacht Show réunit chaque année propriétaires, acheteurs et chantiers autour des plus grands yachts du monde. Pour des clients dont la présence elle-même est une information sensible, nous organisons des visites, rendez-vous et réceptions en toute discrétion.",
      challengesTitle: 'Les enjeux du salon',
      challenges: [
        "La confidentialité des acheteurs et des négociations en cours.",
        'De nombreuses visites à bord, sur les pontons et entre les quais.',
        'Des déplacements entre le port, les hôtels et les bureaux des courtiers.',
        "Une présence internationale qui demande des équipes multilingues."
      ],
      approachTitle: 'Notre dispositif',
      approach: [
        "Planification des visites et des rendez-vous pour limiter l'exposition sur les quais.",
        'Agents de protection rapprochée bilingues, en tenue discrète adaptée au salon.',
        'Coordination avec les courtiers, les capitaines et les équipes des chantiers.',
        'Mobilité sécurisée et suivi par notre centre opérationnel 24/7.'
      ],
      faq: [
        { q: 'Pouvez-vous accompagner des visites privées hors des heures du salon ?', a: "Oui, nous organisons aussi les visites et rendez-vous en dehors des horaires d'ouverture, en lien avec les courtiers." },
        { q: 'Vos agents sont-ils basés à Monaco ?', a: 'Nous disposons d’un bureau à Monaco, au Patio Palace, ce qui nous permet de préparer les dispositifs sur place.' },
        { q: 'Intervenez-vous après le salon ?', a: "Oui, nous assurons aussi la protection lors des essais en mer, des livraisons et des séjours à bord." }
      ]
    },
    en: {
      name: 'Monaco Yacht Show',
      label: 'Event',
      title: 'Close Protection at the Monaco Yacht Show',
      period: 'Late September — Monaco',
      intro: 'Every year the Monaco Yacht Show brings owners, buyers and shipyards together around the world’s largest yachts. For clients whose very presence is sensitive information, we arrange viewings, meetings and receptions with complete discretion.',
      challengesTitle: 'What the show involves',
      challenges: [
        'Confidentiality for buyers and ongoing negotiations.',
        'Many visits on board, along the pontoons and between quays.',
        'Movements between the harbour, hotels and brokers’ offices.',
        'An international audience that calls for multilingual teams.'
      ],
      approachTitle: 'Our approach',
      approach: [
        'Planning viewings and meetings to limit exposure on the quays.',
        'Bilingual close protection officers in discreet attire suited to the show.',
        'Coordination with brokers, captains and shipyard teams.',
        'Secure mobility and monitoring by our 24/7 operations center.'
      ],
      faq: [
        { q: 'Can you accompany private viewings outside show hours?', a: 'Yes, we also arrange viewings and meetings outside opening hours, together with the brokers.' },
        { q: 'Are your officers based in Monaco?', a: 'We have an office in Monaco, at Le Patio Palace, so we prepare details on the ground.' },
        { q: 'Do you work after the show?', a: 'Yes, we also provide protection for sea trials, deliveries and stays on board.' }
      ]
    }
  },
  {
    slug: 'fashion-week-paris',
    path: '/evenements/fashion-week-paris',
    kind: 'event',
    fr: {
      name: 'Fashion Week Paris',
      label: 'Événement',
      title: 'Protection rapprochée pendant la Fashion Week de Paris',
      period: 'Fin février – début mars et fin septembre – début octobre — Paris',
      intro: "Plusieurs défilés par jour, des lieux différents aux quatre coins de Paris et des foules de fans à chaque sortie : la Fashion Week impose un rythme que seule une équipe bien préparée peut suivre. Nous protégeons célébrités, créateurs, mannequins et invités des maisons.",
      challengesTitle: 'Les enjeux de la semaine',
      challenges: [
        'Des foules de fans et de photographes devant chaque lieu de défilé.',
        'Un planning minuté avec plusieurs adresses par jour à travers Paris.',
        'Des arrivées et des sorties très exposées, souvent filmées en direct.',
        'Des soirées et dîners qui prolongent les journées tard dans la nuit.'
      ],
      approachTitle: 'Notre dispositif',
      approach: [
        'Reconnaissance de chaque lieu : entrées, sorties, zones de dépose et itinéraires.',
        'Agents de protection rapprochée et chauffeurs spécialisés pour tenir le planning.',
        'Coordination avec les maisons, les agences et les équipes de production.',
        'Suivi en temps réel depuis notre centre opérationnel 24/7.'
      ],
      faq: [
        { q: 'Pouvez-vous gérer plusieurs personnes en même temps ?', a: 'Oui, nous constituons des équipes à la taille de votre délégation, avec un point de contact unique.' },
        { q: 'Fournissez-vous les véhicules ?', a: 'Oui, nous intégrons chauffeurs et véhicules à nos dispositifs pour enchaîner les défilés sans perte de temps.' },
        { q: 'Intervenez-vous aussi pour les maisons de couture ?', a: "Oui, nous pouvons renforcer la sécurité des invités d'une maison lors de ses défilés et soirées." }
      ]
    },
    en: {
      name: 'Paris Fashion Week',
      label: 'Event',
      title: 'Close Protection during Paris Fashion Week',
      period: 'Late February – early March and late September – early October — Paris',
      intro: 'Several shows a day, venues all over Paris and crowds of fans at every exit: Fashion Week sets a pace only a well-prepared team can keep up with. We protect celebrities, designers, models and fashion house guests.',
      challengesTitle: 'What the week involves',
      challenges: [
        'Crowds of fans and photographers outside every show venue.',
        'A tight schedule with several addresses a day across Paris.',
        'Highly exposed arrivals and departures, often streamed live.',
        'Dinners and parties that stretch days late into the night.'
      ],
      approachTitle: 'Our approach',
      approach: [
        'Reconnaissance of every venue: entrances, exits, drop-off points and routes.',
        'Close protection officers and specialist drivers to keep to the schedule.',
        'Coordination with fashion houses, agencies and production teams.',
        'Real-time monitoring from our 24/7 operations center.'
      ],
      faq: [
        { q: 'Can you look after several people at once?', a: 'Yes, we size the team to your party, with a single point of contact.' },
        { q: 'Do you provide vehicles?', a: 'Yes, drivers and vehicles are part of our details so you can move between shows without losing time.' },
        { q: 'Do you also work for fashion houses?', a: 'Yes, we can strengthen protection for a house’s guests during its shows and parties.' }
      ]
    }
  },
  {
    slug: 'roland-garros',
    path: '/evenements/roland-garros',
    kind: 'event',
    fr: {
      name: 'Roland-Garros',
      label: 'Événement',
      title: 'Protection rapprochée à Roland-Garros',
      period: 'Fin mai – début juin — Paris',
      intro: "Loges, espaces partenaires, entrées et sorties à heure fixe autour de la Porte d'Auteuil : Roland-Garros attire chaque année personnalités, dirigeants et invités internationaux. Nous assurons leur protection entre l'hôtel, le stade et les rendez-vous parisiens.",
      challengesTitle: 'Les enjeux du tournoi',
      challenges: [
        "Des abords du stade très fréquentés à l'arrivée et à la sortie des matchs.",
        "Une circulation difficile dans l'ouest parisien aux heures de pointe.",
        'Des personnalités facilement reconnues dans les tribunes et les allées.',
        'Des journées qui enchaînent matchs, réceptions et dîners.'
      ],
      approachTitle: 'Notre dispositif',
      approach: [
        "Préparation des arrivées, des sorties et des points de dépose autour du stade.",
        'Agents de protection rapprochée présents pendant toute la journée.',
        "Chauffeurs spécialisés et itinéraires alternatifs pour éviter l'attente.",
        'Coordination avec les hôtes des loges et nos équipes de mobilité.'
      ],
      faq: [
        { q: 'Accompagnez-vous vos clients dans les loges ?', a: "Nous adaptons le dispositif aux règles d'accès de chaque espace et aux accréditations disponibles." },
        { q: 'Pouvez-vous intervenir pour une seule journée de match ?', a: "Oui, de la journée unique à l'ensemble du tournoi." },
        { q: 'Organisez-vous aussi les déplacements dans Paris ?', a: 'Oui, nos chauffeurs spécialisés assurent les trajets entre hôtel, stade et rendez-vous.' }
      ]
    },
    en: {
      name: 'Roland-Garros',
      label: 'Event',
      title: 'Close Protection at Roland-Garros',
      period: 'Late May – early June — Paris',
      intro: 'Boxes, partner lounges and fixed arrival times around Porte d’Auteuil: every year Roland-Garros draws public figures, executives and international guests. We protect them between the hotel, the stadium and their Paris engagements.',
      challengesTitle: 'What the tournament involves',
      challenges: [
        'Very busy surroundings when matches start and finish.',
        'Difficult traffic in west Paris at peak times.',
        'Public figures easily recognised in the stands and walkways.',
        'Days that combine matches, receptions and dinners.'
      ],
      approachTitle: 'Our approach',
      approach: [
        'Planning arrivals, departures and drop-off points around the stadium.',
        'Close protection officers on hand all day.',
        'Specialist drivers and alternative routes to avoid waiting.',
        'Coordination with box hosts and our mobility teams.'
      ],
      faq: [
        { q: 'Do you accompany clients into the boxes?', a: 'We adapt the detail to each area’s access rules and the accreditations available.' },
        { q: 'Can you cover a single match day?', a: 'Yes, from a single day to the whole tournament.' },
        { q: 'Do you also handle travel within Paris?', a: 'Yes, our specialist drivers cover trips between hotel, stadium and appointments.' }
      ]
    }
  },
  {
    slug: 'salon-du-bourget',
    path: '/evenements/salon-du-bourget',
    kind: 'event',
    fr: {
      name: 'Salon du Bourget',
      label: 'Événement',
      title: 'Protection rapprochée au Salon du Bourget',
      period: 'Juin, les années impaires — Paris-Le Bourget',
      intro: "Le Salon international de l'aéronautique et de l'espace réunit au Bourget dirigeants d'industrie, délégations officielles et acheteurs du monde entier. Entre chalets d'affaires, démonstrations en vol et rendez-vous confidentiels, nous protégeons les décideurs qui s'y rendent.",
      challengesTitle: 'Les enjeux du salon',
      challenges: [
        'Des délégations et des dirigeants dont la présence et les rendez-vous sont sensibles.',
        "Des accès très contrôlés et des flux importants aux heures d'ouverture.",
        'Des allers-retours entre Paris, le site du Bourget et les aéroports d’affaires.',
        'Une forte présence internationale qui demande des équipes multilingues.'
      ],
      approachTitle: 'Notre dispositif',
      approach: [
        'Préparation des arrivées, des accès aux chalets et des points de dépose.',
        "Agents de protection rapprochée en tenue d'affaires, bilingues.",
        'Chauffeurs spécialisés et itinéraires préparés entre Paris et Le Bourget.',
        'Coordination avec les équipes des exposants et suivi par notre centre opérationnel 24/7.'
      ],
      faq: [
        { q: 'Protégez-vous des délégations entières ?', a: 'Oui, nous dimensionnons l’équipe selon la taille de la délégation, avec un point de contact unique.' },
        { q: 'Pouvez-vous organiser les transferts depuis les aéroports d’affaires ?', a: "Oui, nos chauffeurs assurent les transferts entre les aéroports, Paris et le site du salon." },
        { q: 'Intervenez-vous aussi pour les soirées organisées pendant le salon ?', a: 'Oui, nous couvrons les dîners et réceptions qui suivent les journées du salon.' }
      ]
    },
    en: {
      name: 'Paris Air Show',
      label: 'Event',
      title: 'Close Protection at the Paris Air Show (Le Bourget)',
      period: 'June, odd-numbered years — Paris-Le Bourget',
      intro: 'The Paris Air Show brings industry leaders, official delegations and buyers from around the world to Le Bourget. Between business chalets, flying displays and confidential meetings, we protect the decision-makers who attend.',
      challengesTitle: 'What the show involves',
      challenges: [
        'Delegations and executives whose presence and meetings are sensitive.',
        'Tightly controlled access and heavy crowds during opening hours.',
        'Trips between Paris, the Le Bourget site and business airports.',
        'A strong international presence that calls for multilingual teams.'
      ],
      approachTitle: 'Our approach',
      approach: [
        'Planning arrivals, chalet access and drop-off points.',
        'Bilingual close protection officers in business attire.',
        'Specialist drivers and prepared routes between Paris and Le Bourget.',
        'Coordination with exhibitor teams and monitoring by our 24/7 operations center.'
      ],
      faq: [
        { q: 'Do you protect whole delegations?', a: 'Yes, we size the team to the delegation, with a single point of contact.' },
        { q: 'Can you arrange transfers from business airports?', a: 'Yes, our drivers handle transfers between the airports, Paris and the show site.' },
        { q: 'Do you also cover evening events during the show?', a: 'Yes, we cover the dinners and receptions that follow the show days.' }
      ]
    }
  },
  {
    slug: 'cannes-lions',
    path: '/evenements/cannes-lions',
    kind: 'event',
    fr: {
      name: 'Cannes Lions',
      label: 'Événement',
      title: 'Protection rapprochée aux Cannes Lions',
      period: 'Juin — Cannes',
      intro: "Chaque mois de juin, les Cannes Lions réunissent les dirigeants des grandes marques, des agences et des plateformes, ainsi que de nombreuses personnalités invitées. Entre conférences au Palais des Festivals, rendez-vous sur la Croisette et soirées sur les plages et les yachts, nous assurons leur protection.",
      challengesTitle: 'Les enjeux du festival',
      challenges: [
        'Des dirigeants et des invités célèbres très sollicités sur la Croisette.',
        'Un programme serré entre conférences, rendez-vous et soirées.',
        'Des soirées sur les plages privées et à bord de yachts.',
        'Une circulation difficile dans Cannes pendant toute la semaine.'
      ],
      approachTitle: 'Notre dispositif',
      approach: [
        'Préparation des interventions, des rendez-vous et des déplacements de la journée.',
        'Agents de protection rapprochée discrets, adaptés aux contextes professionnels.',
        'Chauffeurs spécialisés et itinéraires préparés à travers Cannes.',
        'Coordination avec les organisateurs des soirées et les équipes des marques.'
      ],
      faq: [
        { q: 'Protégez-vous les intervenants des conférences ?', a: "Oui, nous accompagnons les intervenants de leur arrivée à leur départ, en lien avec les équipes de l'événement." },
        { q: 'Couvrez-vous les soirées sur la plage ou en mer ?', a: 'Oui, nous intervenons sur les soirées organisées sur les plages privées et à bord des yachts.' },
        { q: 'Pouvez-vous protéger plusieurs dirigeants d’une même entreprise ?', a: 'Oui, nous constituons une équipe adaptée avec un point de contact unique.' }
      ]
    },
    en: {
      name: 'Cannes Lions',
      label: 'Event',
      title: 'Close Protection at Cannes Lions',
      period: 'June — Cannes',
      intro: 'Every June, Cannes Lions brings together leaders of major brands, agencies and platforms, along with many high-profile guests. Between talks at the Palais des Festivals, meetings on the Croisette and parties on beaches and yachts, we keep them protected.',
      challengesTitle: 'What the festival involves',
      challenges: [
        'Executives and celebrity guests in high demand on the Croisette.',
        'A tight programme of talks, meetings and parties.',
        'Parties at beach clubs and on board yachts.',
        'Difficult traffic in Cannes throughout the week.'
      ],
      approachTitle: 'Our approach',
      approach: [
        'Planning each day’s talks, meetings and movements.',
        'Discreet close protection officers suited to professional settings.',
        'Specialist drivers and prepared routes across Cannes.',
        'Coordination with party hosts and brand teams.'
      ],
      faq: [
        { q: 'Do you protect conference speakers?', a: 'Yes, we accompany speakers from arrival to departure, together with the event teams.' },
        { q: 'Do you cover beach and yacht parties?', a: 'Yes, we work at parties held at beach clubs and on board yachts.' },
        { q: 'Can you protect several executives from one company?', a: 'Yes, we build a suitable team with a single point of contact.' }
      ]
    }
  },
  {
    slug: 'palaces-paris',
    path: '/destinations/palaces-paris',
    kind: 'destination',
    fr: {
      name: 'Palaces de Paris',
      label: 'Destination',
      title: 'Garde du corps pour votre séjour dans un palace parisien',
      period: 'Toute l’année — Paris',
      intro: "Four Seasons George V, Ritz Paris, Plaza Athénée, Le Bristol, Hôtel de Crillon, Bulgari Hotel Paris, Fouquet's, Peninsula, Shangri-La, Cheval Blanc, Mandarin Oriental, Royal Monceau : lorsque vous séjournez dans l'un des palaces et grands hôtels de Paris, nous assurons votre protection de l'arrivée à l'aéroport jusqu'au départ, à l'hôtel comme lors de chacun de vos déplacements.",
      note: "ALTES Protection n'est affiliée à aucun de ces établissements : les noms sont cités pour indiquer où séjournent nos clients.",
      challengesTitle: 'Les enjeux d’un séjour à Paris',
      challenges: [
        'Des halls et des entrées très fréquentés, surveillés par les photographes et les curieux.',
        'Des déplacements quotidiens entre l’hôtel, les rendez-vous d’affaires, les boutiques et les restaurants.',
        'Des arrivées et des départs à organiser depuis les aéroports de Paris et du Bourget.',
        'Le besoin de préserver la tranquillité et la confidentialité du séjour.'
      ],
      approachTitle: 'Notre dispositif',
      approach: [
        "Accueil à l'aéroport et transferts avec nos chauffeurs spécialisés.",
        "Coordination avec la conciergerie et les équipes de sécurité de l'hôtel, dans le respect de leurs règles.",
        'Protection rapprochée lors de chaque sortie : rendez-vous, shopping, dîners, événements.',
        'Suivi en temps réel par notre centre opérationnel 24/7, basé en région parisienne.'
      ],
      faq: [
        { q: 'Pouvez-vous intervenir dans n’importe quel hôtel parisien ?', a: "Oui, nous intervenons auprès de nos clients quel que soit leur hôtel, en lien avec la conciergerie et la sécurité de l'établissement." },
        { q: 'Combien de temps à l’avance faut-il réserver ?', a: 'Idéalement quelques jours avant votre arrivée. Nous étudions aussi les demandes urgentes.' },
        { q: 'Votre présence est-elle discrète à l’hôtel ?', a: 'Oui, nos agents adaptent leur tenue et leur positionnement pour rester discrets dans les espaces de l’hôtel.' }
      ]
    },
    en: {
      name: 'Paris palace hotels',
      label: 'Destination',
      title: 'Bodyguards for Your Stay at a Paris Palace Hotel',
      period: 'All year round — Paris',
      intro: 'Four Seasons George V, Ritz Paris, Plaza Athénée, Le Bristol, Hôtel de Crillon, Bulgari Hotel Paris, Fouquet’s, The Peninsula, Shangri-La, Cheval Blanc, Mandarin Oriental, Le Royal Monceau: when you stay at one of the palace and luxury hotels of Paris, we protect you from airport arrival to departure, at the hotel and on every outing.',
      note: 'ALTES Protection is not affiliated with any of these hotels: they are named to show where our clients stay.',
      challengesTitle: 'What a Paris stay involves',
      challenges: [
        'Busy lobbies and entrances, watched by photographers and onlookers.',
        'Daily trips between the hotel, business meetings, boutiques and restaurants.',
        'Arrivals and departures to organise from the Paris and Le Bourget airports.',
        'The need to keep the stay calm and confidential.'
      ],
      approachTitle: 'Our approach',
      approach: [
        'Airport meet-and-greet and transfers with our specialist drivers.',
        'Coordination with the hotel concierge and security teams, respecting their rules.',
        'Close protection on every outing: meetings, shopping, dinners and events.',
        'Real-time monitoring by our 24/7 operations center near Paris.'
      ],
      faq: [
        { q: 'Can you work at any Paris hotel?', a: 'Yes, we look after our clients whatever their hotel, together with its concierge and security.' },
        { q: 'How far in advance should we book?', a: 'Ideally a few days before you arrive. We also consider urgent requests.' },
        { q: 'Is your presence discreet at the hotel?', a: 'Yes, our officers adapt their attire and positioning to stay discreet in the hotel’s spaces.' }
      ]
    }
  },
  {
    slug: 'palaces-monaco-cote-azur',
    path: '/destinations/palaces-monaco-cote-azur',
    kind: 'destination',
    fr: {
      name: 'Palaces de Monaco et du Sud',
      label: 'Destination',
      title: 'Garde du corps dans les palaces et 5 étoiles de Monaco et du Sud',
      period: 'Toute l’année — Monaco, Cap-Ferrat, Cannes, Antibes, Saint-Tropez',
      intro: "À Monaco, à l'Hôtel de Paris Monte-Carlo, à l'Hôtel Hermitage, au Métropole, au Fairmont, au Monte-Carlo Bay ou au Monte-Carlo Beach. Sur la Côte d'Azur, au Grand-Hôtel du Cap-Ferrat, à La Réserve de Beaulieu, à l'Hôtel du Cap-Eden-Roc, au Château Saint-Martin, au Carlton, au Martinez ou au Majestic. À Saint-Tropez, au Cheval Blanc, au Byblos ou à La Réserve Ramatuelle. Depuis notre bureau de Monaco, nous protégeons les clients qui séjournent dans les palaces et les grands 5 étoiles du Sud, pour un week-end comme pour toute la saison.",
      note: "ALTES Protection n'est affiliée à aucun de ces établissements : les noms sont cités pour indiquer où séjournent nos clients.",
      challengesTitle: 'Les enjeux d’un séjour sur la Riviera',
      challenges: [
        'Des déplacements fréquents entre Monaco, Cannes, Antibes et Saint-Tropez.',
        'Des arrivées par l’aéroport de Nice, en hélicoptère ou par la mer.',
        'Une forte présence de photographes pendant les grands événements.',
        'Des séjours en famille qui demandent une protection continue et discrète.'
      ],
      approachTitle: 'Notre dispositif',
      approach: [
        "Accueil à l'aéroport de Nice et transferts vers l'hôtel.",
        "Coordination avec la conciergerie et la sécurité de l'établissement.",
        'Protection lors des sorties, des dîners, des soirées et des journées en mer.',
        'Équipes basées à Monaco et suivi par notre centre opérationnel 24/7.'
      ],
      faq: [
        { q: 'Intervenez-vous dans toute la région ?', a: 'Oui, nous couvrons Monaco, Nice, le Cap-Ferrat, Antibes, Cannes et Saint-Tropez.' },
        { q: 'Pouvez-vous assurer un séjour de plusieurs semaines ?', a: 'Oui, nous organisons des dispositifs longs avec des équipes et des relèves planifiées.' },
        { q: 'Organisez-vous les transferts en hélicoptère ?', a: "Oui, nous coordonnons les transferts depuis l'aéroport de Nice, y compris en hélicoptère." }
      ]
    },
    en: {
      name: 'Monaco & South of France palace hotels',
      label: 'Destination',
      title: 'Bodyguards at Palace and Five-Star Hotels in Monaco and the South of France',
      period: 'All year round — Monaco, Cap-Ferrat, Cannes, Antibes, Saint-Tropez',
      intro: 'In Monaco: Hôtel de Paris Monte-Carlo, Hôtel Hermitage, the Métropole, the Fairmont, Monte-Carlo Bay or Monte-Carlo Beach. On the Riviera: Grand-Hôtel du Cap-Ferrat, La Réserve de Beaulieu, Hôtel du Cap-Eden-Roc, Château Saint-Martin, the Carlton, the Martinez or the Majestic. In Saint-Tropez: Cheval Blanc, Byblos or La Réserve Ramatuelle. From our Monaco office, we protect clients staying at the palace and five-star hotels of the South of France, for a weekend or for the whole season.',
      note: 'ALTES Protection is not affiliated with any of these hotels: they are named to show where our clients stay.',
      challengesTitle: 'What a Riviera stay involves',
      challenges: [
        'Frequent trips between Monaco, Cannes, Antibes and Saint-Tropez.',
        'Arrivals through Nice airport, by helicopter or by sea.',
        'Heavy photographer presence during major events.',
        'Family stays that need continuous, discreet protection.'
      ],
      approachTitle: 'Our approach',
      approach: [
        'Nice airport meet-and-greet and transfers to the hotel.',
        'Coordination with the hotel concierge and security.',
        'Protection for outings, dinners, parties and days at sea.',
        'Teams based in Monaco and monitoring by our 24/7 operations center.'
      ],
      faq: [
        { q: 'Do you cover the whole region?', a: 'Yes, we cover Monaco, Nice, Cap-Ferrat, Antibes, Cannes and Saint-Tropez.' },
        { q: 'Can you cover a stay of several weeks?', a: 'Yes, we run long details with planned teams and rotations.' },
        { q: 'Do you arrange helicopter transfers?', a: 'Yes, we coordinate transfers from Nice airport, including by helicopter.' }
      ]
    }
  },
  {
    slug: 'saint-tropez',
    path: '/destinations/saint-tropez',
    kind: 'destination',
    fr: {
      name: 'Saint-Tropez',
      label: 'Destination',
      title: 'Protection rapprochée à Saint-Tropez',
      period: 'Juillet – août — Saint-Tropez et presqu’île',
      intro: "Villas sur les hauteurs, yachts au mouillage, plages privées et soirées : l'été à Saint-Tropez se vit dans un périmètre réduit, très fréquenté et très observé. Nous accompagnons familles et personnalités pour des séjours de quelques jours à toute la saison.",
      challengesTitle: 'Les enjeux de la saison',
      challenges: [
        'Une route d’accès saturée qui impose d’anticiper chaque trajet.',
        'Une forte présence de photographes sur le port et sur les plages.',
        'Des séjours longs, en famille, qui demandent une protection continue mais discrète.',
        'Des transferts par la mer ou par hélicoptère à coordonner.'
      ],
      approachTitle: 'Notre dispositif',
      approach: [
        'Protection des déplacements, des sorties et des soirées, de jour comme de nuit.',
        'Sécurisation des résidences en lien avec le personnel de maison.',
        'Coordination avec les capitaines, les plages privées et les établissements.',
        'Équipes organisées pour durer toute la saison, avec relèves planifiées.'
      ],
      faq: [
        { q: 'Pouvez-vous assurer une présence sur toute la saison ?', a: "Oui, nous organisons des dispositifs sur plusieurs semaines avec des équipes et des relèves planifiées." },
        { q: 'Protégez-vous aussi les enfants ?', a: 'Oui, nous adaptons le dispositif aux familles, avec des agents dédiés aux enfants si nécessaire.' },
        { q: 'Intervenez-vous sur toute la Côte d’Azur ?', a: 'Oui, depuis notre bureau de Monaco, nous couvrons Saint-Tropez, Cannes, Antibes, Nice et Monaco.' }
      ]
    },
    en: {
      name: 'Saint-Tropez',
      label: 'Destination',
      title: 'Close Protection in Saint-Tropez',
      period: 'July – August — Saint-Tropez and peninsula',
      intro: 'Hillside villas, yachts at anchor, beach clubs and parties: summer in Saint-Tropez happens in a small, crowded and closely watched area. We look after families and public figures for stays from a few days to the whole season.',
      challengesTitle: 'What the season involves',
      challenges: [
        'A single congested access road that means planning every trip.',
        'A heavy photographer presence at the port and on the beaches.',
        'Long family stays that need continuous but discreet protection.',
        'Sea and helicopter transfers to coordinate.'
      ],
      approachTitle: 'Our approach',
      approach: [
        'Protection for movements, outings and parties, day and night.',
        'Residential security in coordination with household staff.',
        'Coordination with captains, beach clubs and venues.',
        'Teams organised to last the whole season, with planned rotations.'
      ],
      faq: [
        { q: 'Can you stay for the whole season?', a: 'Yes, we run multi-week details with planned teams and rotations.' },
        { q: 'Do you also protect children?', a: 'Yes, we adapt the detail to families, with officers dedicated to the children when needed.' },
        { q: 'Do you cover the whole French Riviera?', a: 'Yes, from our Monaco office we cover Saint-Tropez, Cannes, Antibes, Nice and Monaco.' }
      ]
    }
  },
  {
    slug: 'courchevel',
    path: '/destinations/courchevel',
    kind: 'destination',
    fr: {
      name: 'Courchevel',
      label: 'Destination',
      title: 'Protection rapprochée à Courchevel',
      period: 'Décembre – avril — Courchevel et Trois Vallées',
      intro: "Chalets privés, restaurants d'altitude, pistes et arrivées à l'altiport : la saison à Courchevel réunit une clientèle internationale dans un village où tout le monde se croise. Nous protégeons familles et personnalités pendant leur séjour, sur les pistes comme en dehors.",
      challengesTitle: 'Les enjeux de la saison',
      challenges: [
        "Des arrivées par l'altiport ou par la route à coordonner selon la météo.",
        'Un village compact où les personnalités sont rapidement repérées.',
        'Des journées partagées entre ski, restaurants et activités en famille.',
        'Des conditions de montagne qui demandent des équipes préparées.'
      ],
      approachTitle: 'Notre dispositif',
      approach: [
        'Accueil et transferts depuis les aéroports de Genève, Lyon ou Chambéry et l’altiport.',
        'Protection des sorties, des restaurants et des soirées pendant tout le séjour.',
        'Sécurisation des chalets en lien avec les conciergeries et le personnel.',
        'Agents en mesure d’accompagner sur les pistes, selon le programme.'
      ],
      faq: [
        { q: 'Vos agents peuvent-ils skier avec vous ?', a: "Oui, nous constituons l'équipe en fonction du programme, y compris pour accompagner sur les pistes." },
        { q: 'Pouvez-vous organiser les transferts depuis Genève ?', a: 'Oui, nos chauffeurs spécialisés assurent les transferts depuis les aéroports et vers l’altiport.' },
        { q: 'Intervenez-vous pour les fêtes de fin d’année ?', a: "Oui, c'est l'une des périodes les plus demandées : nous conseillons de réserver tôt." }
      ]
    },
    en: {
      name: 'Courchevel',
      label: 'Destination',
      title: 'Close Protection in Courchevel',
      period: 'December – April — Courchevel and Les Trois Vallées',
      intro: 'Private chalets, mountain restaurants, slopes and arrivals at the altiport: the Courchevel season brings an international clientele to a village where everyone crosses paths. We protect families and public figures throughout their stay, on and off the slopes.',
      challengesTitle: 'What the season involves',
      challenges: [
        'Arrivals by altiport or by road to coordinate with the weather.',
        'A compact village where public figures are quickly recognised.',
        'Days split between skiing, restaurants and family activities.',
        'Mountain conditions that call for prepared teams.'
      ],
      approachTitle: 'Our approach',
      approach: [
        'Meet-and-greet and transfers from Geneva, Lyon or Chambéry airports and the altiport.',
        'Protection for outings, restaurants and evenings throughout the stay.',
        'Chalet security in coordination with concierge services and staff.',
        'Officers able to accompany you on the slopes, depending on the programme.'
      ],
      faq: [
        { q: 'Can your officers ski with us?', a: 'Yes, we build the team around your programme, including accompanying you on the slopes.' },
        { q: 'Can you arrange transfers from Geneva?', a: 'Yes, our specialist drivers handle transfers from the airports and to the altiport.' },
        { q: 'Do you work over the festive season?', a: 'Yes, it is one of the busiest periods: we recommend booking early.' }
      ]
    }
  }
];

export default events;
